<template>
  <div>
    <!-- <v-container> -->
    <v-layout wrap>
      <v-flex xs12 sm6> </v-flex>
      <v-flex xs12 sm6 class="text-xs-right">
        <v-btn dark small color="primary" @click="addBooking">
          <i class="fa fa-plus middle mr-2"></i> {{ $t('add_slot') }}</v-btn
        >
      </v-flex>
    </v-layout>
    <div>
      <v-dialog v-if="isEditDialog" persistent v-model="isEditDialog" max-width="800">
        <v-card>
          <v-card-text>
            <h2 class="mb-2">
              {{ $t('calendar_setting') }}
            </h2>
            <div>
              <v-tabs
                v-model="currentView"
                color="white"
                :slider-color="$vuetify.theme.primary"
                show-arrows
                v-if="!isEdit"
              >
                <v-tab ripple :key="'common'" :href="'#common'" @click="errorDateTime = false">
                  {{ $t('common') }}
                </v-tab>

                <v-tab ripple :key="'advanced'" :href="'#advanced'" @click="errorDateTime = false">
                  {{ $t('advance') }}
                </v-tab>
              </v-tabs>
            </div>

            <template v-if="currentView == 'common'">
              <sub-booking-form
                v-model="subBookingEditCommon"
                :isEditDialog.sync="isEditDialog"
                :isEdit="isEdit"
                :errorDateTime="errorDateTime"
                :loading="loading"
                @saveSubBookingCommon="saveSubBookingCommon"
              ></sub-booking-form>
            </template>
            <template v-if="currentView == 'advanced'">
              <sub-booking-advanced-form
                v-model="subBookingEdit"
                :isEditDialog.sync="isEditDialog"
                :isEdit="isEdit"
                :errorDateTime.sync="errorDateTime"
                :loading="loading"
                @saveSubBooking="saveSubBooking"
                :toggleType.sync="toggleType"
              ></sub-booking-advanced-form>
            </template>
          </v-card-text>
        </v-card>
      </v-dialog>
      <div v-if="loading">
        <div class="spinner text-xs-center mb-5 mt-5">
          <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
        </div>
      </div>
      <template v-else>
        <template v-if="data.length < 1">
          <div class="intent-item z-border-red text-xs-center" style="padding: 10px 15px 10px;">
            <h3>{{ $t('booking_not_found') }}</h3>
            <span>{{ $t('please_add_slot') }}</span>
          </div>
        </template>
        <template v-else>
          <div class="text-xs-right mb-2">
            <v-pagination
              v-if="pagelength > 1"
              :total-visible="5"
              v-model="pageNumber"
              :length="pagelength"
              @input="changePage"
            ></v-pagination>
          </div>
          <div
            class="intent-item z-border-red"
            style="padding: 10px 15px 10px;"
            v-for="(item, index) in data"
            :key="index"
          >
            <h3>{{ $t('name') }} : {{ item.sub_booking_name }}</h3>
            <v-layout wrap>
              <v-flex xs12 sm9 class="pa-2">
                <tr>
                  <td class="primary-color">{{ $t('start_date_booking') }}</td>
                  <td style="color:#000" class="pl-2">
                    {{
                      item.start_at
                        ? getFormatDate(item.start_at, 'dddd, D MMMM, YYYY h:mm A')
                        : '-'
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="primary-color">{{ $t('end_date_booking') }}</td>
                  <td style="color:#000" class="pl-2">
                    {{
                      item.end_at ? getFormatDate(item.end_at, 'dddd, D MMMM , YYYY h:mm A') : '-'
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="primary-color">
                    {{ $t('bookings_per_time') }}
                  </td>
                  <td style="color:#000" class="pl-2">{{ item.max_available_slot }}</td>
                </tr>
                <tr>
                  <td class="primary-color">{{ $t('booked') }}</td>
                  <td style="color:#000" class="pl-2">{{ item.available_slot }}</td>
                </tr>
              </v-flex>

              <v-flex xs12 sm3 class="text-xs-right">
                <v-btn
                  fab
                  outline
                  color="primary"
                  class="extra-small ma-1"
                  @click="setEditBooking(item)"
                >
                  <i class="fas fa-pencil-alt"></i>
                </v-btn>
                <v-btn
                  fab
                  outline
                  color="primary"
                  class="extra-small ma-1"
                  @click="deleteSubBookingConfigCalendar(item)"
                >
                  <i class="fa fa-trash middle"></i>
                </v-btn>
                <div>
                  <v-btn dark small color="primary" @click="callDetailDialog(item)">
                    <i class="fa fa-calendar middle mr-2"></i
                    >{{ $t('booking_detail_summary') }}</v-btn
                  >
                </div>
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-right">
            <v-pagination
              v-if="pagelength > 1"
              :total-visible="5"
              v-model="pageNumber"
              :length="pagelength"
              @input="changePage"
            ></v-pagination>
          </div>
        </template>
      </template>
    </div>
    <v-dialog v-if="dialogDetail" persistent v-model="dialogDetail" max-width="1000"
      ><detail-booking @closeDetailDialog="closeDetailDialog" v-model="dataToCallDetail">
      </detail-booking
    ></v-dialog>
    <!-- </v-container> -->
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import DetailBooking from './DetailBooking.vue'
import SubBookingForm from './SubBookingForm.vue'
import SubBookingAdvancedForm from './SubBookingAdvancedForm.vue'
import dayjs from 'dayjs'
export default {
  props: ['BookingId'],
  data() {
    return {
      data: [],
      weekday: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      toggleType: false,
      isEdit: false,
      currentView: 'common',
      isEditDialog: false,
      subBookingEdit: {},
      subBookingEditCommon: [],
      loading: false,
      pageNumber: 1,
      pagelength: 0,
      limit: 5,
      offset: 0,
      dialogDetail: false,
      dataToCallDetail: {},
      errorDateTime: false
    }
  },
  components: {
    DetailBooking,
    SubBookingForm,
    SubBookingAdvancedForm
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  mounted() {
    const vm = this
    vm.getSubBookingConfigCalendar()
  },
  methods: {
    addBooking() {
      const vm = this
      vm.subBookingEditCommon = []
      vm.subBookingEdit = {
        startAtTime: { HH: '00', mm: '00' },
        endAtTime: { HH: '00', mm: '00' },
        startAtDate: dayjs().format('YYYY-MM-DD'),
        endAtDate: dayjs().format('YYYY-MM-DD'),
        selectDate: [dayjs().format('YYYY-MM-DD')],
        date: vm.weekday
      }
      vm.subBookingEditCommon.push(vm.subBookingEdit)
      vm.currentView = 'common'
      vm.toggleType = false
      vm.isEditDialog = true
      vm.errorDateTime = false
      vm.isEdit = false
    },

    closeDetailDialog() {
      const vm = this
      vm.dialogDetail = false
    },
    callDetailDialog(subBooking) {
      const vm = this
      vm.dialogDetail = true
      vm.dataToCallDetail = subBooking
      vm.dataToCallDetail.BookingId = vm.BookingId
    },
    setEditBooking(item) {
      const vm = this
      vm.subBookingEdit = {}
      vm.subBookingEdit.startAtTime = {}
      vm.subBookingEdit.endAtTime = {}
      vm.subBookingEdit.id = item.id
      vm.subBookingEdit.max_available_slot = item.max_available_slot
      vm.subBookingEdit.sub_booking_name = item.sub_booking_name
      vm.subBookingEdit.startAtDate = vm.getFormatDate(item.start_at, 'YYYY-MM-DD')
      vm.subBookingEdit.startAtTime.HH = vm.getFormatDate(item.start_at, 'HH')
      vm.subBookingEdit.startAtTime.mm = vm.getFormatDate(item.start_at, 'mm')

      vm.subBookingEdit.endAtDate = vm.getFormatDate(item.end_at, 'YYYY-MM-DD')
      vm.subBookingEdit.endAtTime.HH = vm.getFormatDate(item.end_at, 'HH')
      vm.subBookingEdit.endAtTime.mm = vm.getFormatDate(item.end_at, 'mm')
      //   vm.subBookingEdit = item
      vm.currentView = 'advanced'
      vm.isEditDialog = true
      vm.toggleType = true
      vm.isEdit = true
      vm.errorDateTime = false
    },
    changePage() {
      const vm = this
      vm.offset = vm.pageNumber * vm.limit - vm.limit
      vm.getSubBookingConfigCalendar()
    },
    async getSubBookingConfigCalendar() {
      const vm = this
      vm.loading = true
      vm.data = null
      const data = {
        pageId: vm.selectedBot.pageid,
        booking_config_id: vm.BookingId,
        params: {
          limit: vm.limit,
          offset: vm.offset
        }
      }
      let response = await api.getSubBookingConfigCalendar(data)
      if (response.success && response.result) {
        vm.data = response.result
        vm.pagelength = Math.ceil(response.total_count / vm.limit)
      }
      vm.loading = false
    },
    async saveSubBookingCommon() {
      const vm = this
      if (vm.subBookingEditCommon && vm.subBookingEditCommon.length > 0) {
        let checkDate = vm.subBookingEditCommon.some(
          item =>
            `${item.startAtDate || ''} ${item.startAtTime ? item.startAtTime.HH : ''}:${
              item.startAtTime ? item.startAtTime.mm : ''
            }:00` >=
            `${item.endAtDate || ''} ${item.endAtTime ? item.endAtTime.HH : ''}:${
              item.endAtTime ? item.endAtTime.mm : ''
            }:00`
        )
        if (!checkDate) {
          vm.errorDateTime = false
          let data = []
          vm.subBookingEditCommon.map(item => {
            data.push({
              max_available_slot: parseInt(item.max_available_slot) || '',
              sub_booking_name: `${item.sub_booking_name}: ${item.startAtDate}`,
              start_at: `${item.startAtDate || ''} ${item.startAtTime ? item.startAtTime.HH : ''}:${
                item.startAtTime ? item.startAtTime.mm : ''
              }:00`,
              end_at: `${item.endAtDate || ''} ${item.endAtTime ? item.endAtTime.HH : ''}:${
                item.endAtTime ? item.endAtTime.mm : ''
              }:00`
            })
          })

          vm.postSubBookingConfigCalendar(data, 'common')
        } else {
          vm.errorDateTime = true
        }
      }
    },
    async saveSubBooking() {
      const vm = this
      if (
        `${vm.subBookingEdit.startAtDate || ''} ${
          vm.subBookingEdit.startAtTime ? vm.subBookingEdit.startAtTime.HH : ''
        }:${vm.subBookingEdit.startAtTime ? vm.subBookingEdit.startAtTime.mm : ''}:00` <
        `${vm.subBookingEdit.endAtDate || ''} ${
          vm.subBookingEdit.endAtTime ? vm.subBookingEdit.endAtTime.HH : ''
        }:${vm.subBookingEdit.endAtTime ? vm.subBookingEdit.endAtTime.mm : ''}:00`
      ) {
        if (
          (!vm.toggleType && vm.subBookingEdit.selectDate <= 0) ||
          (vm.toggleType && vm.subBookingEdit.date <= 0)
        ) {
          vm.errorDateTime = true
        } else {
          vm.errorDateTime = false
          if (vm.isEdit) {
            vm.putSubBookingConfigCalendar(vm.subBookingEdit)
          } else {
            vm.postSubBookingConfigCalendar(vm.subBookingEdit, 'advanced')
          }
        }
      } else {
        vm.errorDateTime = true
      }
    },
    getFormatDate: function(date, format) {
      const vm = this
      return dayjs(date)
        .locale(vm.currentLang)
        .format(format)
    },

    formatdataToSave(subBookingEdit) {
      const vm = this
      if (subBookingEdit) {
        if (vm.isEdit) {
          let value = {}
          value.max_available_slot = parseInt(subBookingEdit.max_available_slot) || ''
          value.sub_booking_name = subBookingEdit.sub_booking_name || ''
          value.start_at = `${subBookingEdit.startAtDate || ''} ${
            subBookingEdit.startAtTime ? subBookingEdit.startAtTime.HH : ''
          }:${subBookingEdit.startAtTime ? subBookingEdit.startAtTime.mm : ''}:00`
          value.end_at = `${subBookingEdit.endAtDate || ''} ${
            subBookingEdit.endAtTime ? subBookingEdit.endAtTime.HH : ''
          }:${subBookingEdit.endAtTime ? subBookingEdit.endAtTime.mm : ''}:00`
          return value
        } else {
          let data = []
          if (!vm.toggleType && subBookingEdit.selectDate.length > 0) {
            subBookingEdit.selectDate.map(item => {
              data.push({
                max_available_slot: parseInt(subBookingEdit.max_available_slot) || '',
                sub_booking_name: `${subBookingEdit.sub_booking_name}: ${item}`,
                start_at: `${item || ''} ${
                  subBookingEdit.startAtTime ? subBookingEdit.startAtTime.HH : ''
                }:${subBookingEdit.startAtTime ? subBookingEdit.startAtTime.mm : ''}:00`,
                end_at: `${item || ''} ${
                  subBookingEdit.endAtTime ? subBookingEdit.endAtTime.HH : ''
                }:${subBookingEdit.endAtTime ? subBookingEdit.endAtTime.mm : ''}:00`
              })
            })
          } else {
            let days = []
            console.log(subBookingEdit)
            vm.getDatesInRange(subBookingEdit.startAtDate, subBookingEdit.endAtDate).map(item => {
              if (subBookingEdit.date.includes(vm.weekday[item.getDay()])) {
                days.push(vm.getFormatDate(item, 'YYYY-MM-DD'))
              }
            })
            console.log(days)
            days.map(item => {
              data.push({
                max_available_slot: parseInt(subBookingEdit.max_available_slot) || '',
                sub_booking_name: `${subBookingEdit.sub_booking_name}: ${item}`,
                start_at: `${item || ''} ${
                  subBookingEdit.startAtTime ? subBookingEdit.startAtTime.HH : ''
                }:${subBookingEdit.startAtTime ? subBookingEdit.startAtTime.mm : ''}:00`,
                end_at: `${item || ''} ${
                  subBookingEdit.endAtTime ? subBookingEdit.endAtTime.HH : ''
                }:${subBookingEdit.endAtTime ? subBookingEdit.endAtTime.mm : ''}:00`
              })
            })
          }
          console.log(data)
          return data
        }
      }
    },

    getDatesInRange(startDate, endDate) {
      for (
        var arr = [], dt = new Date(startDate);
        dt <= new Date(endDate);
        dt.setDate(dt.getDate() + 1)
      ) {
        arr.push(new Date(dt))
      }
      return arr
    },
    async postSubBookingConfigCalendar(subBookingEdit, type) {
      const vm = this
      try {
        console.log(type)
        vm.loading = true
        var res = await api.postSubBookingConfigCalendar({
          pageId: vm.selectedBot.pageid,
          booking_config_id: vm.BookingId,
          body: {
            sub_booking_data:
              type === 'common' ? subBookingEdit : vm.formatdataToSave(subBookingEdit)
          }
        })
        if (res.success) {
          const newArray = res.result.concat(vm.data)
          vm.data = newArray
          vm.isEditDialog = false
          vm.$swal.fire({
            title: vm.$t('Successfully'),
            text: `${vm.$t('booking')} ${subBookingEdit.sub_booking_name || ''} ${vm.$t(
              'has_been_added'
            )}`,
            type: 'success'
          })
          vm.subBookingEdit = {}
          vm.loading = false
        } else {
          vm.loading = false
        }
      } catch (error) {
        vm.$swal.fire({
          title: vm.$t('something_went_wrong'),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm'),
          reverseButtons: true
        })
        vm.loading = false
      }
    },
    async putSubBookingConfigCalendar(subBookingEdit) {
      const vm = this
      vm.loading = true
      var res = await api.putSubBookingConfigCalendar({
        pageId: vm.selectedBot.pageid,
        booking_config_id: vm.BookingId,
        sub_booking_config_id: subBookingEdit.id,
        body: vm.formatdataToSave(subBookingEdit)
      })
      if (res.success) {
        var data = []
        if (vm.data.length !== 0) {
          vm.data.map(item => {
            if (item.id === subBookingEdit.id) {
              item = res.result
            }
            data.push(item)
          })
        }
        vm.data = data
        vm.isEditDialog = false
        vm.$swal.fire({
          title: vm.$t('Successfully'),
          text: `${vm.$t('booking')} ${subBookingEdit.sub_booking_name} ${vm.$t(
            'has_been_edited'
          )}`,
          type: 'success'
        })
        vm.subBookingEdit = {}
        vm.loading = false
      } else {
        vm.loading = false
      }
    },
    async deleteSubBookingConfigCalendar(subBookingEdit) {
      const vm = this
      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to delete {name}?', {
          name: subBookingEdit.sub_booking_name
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loading = true
        var res = await api.deleteSubBookingConfigCalendar({
          pageId: vm.selectedBot.pageid,
          booking_config_id: vm.BookingId,
          sub_booking_config_id: subBookingEdit.id
        })
        if (res.success) {
          vm.data = vm.data.filter(item => item.id !== subBookingEdit.id)
          vm.isShow = false
          vm.isEdit = false
          vm.$swal.fire({
            title: vm.$t('Successfully'),
            text: `${vm.$t('booking')} ${subBookingEdit.sub_booking_name} ${vm.$t(
              'has_been_deleted'
            )}`,
            type: 'success'
          })

          vm.loading = false
        } else {
          vm.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-select.v-select--chips .v-select__selections {
  min-height: 42px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/view/intent/calendar/SubBooking.vue